import { adminHttpClient } from '../commons/adminHttpClient'
import { BenefitDesignStatus } from 'domain/benefit/benefitDesignStatus'
import AllowanceType from '../../domain/benefit/allowanceType'

export type BenefitDetailsResponse = {
  id: string
  startDate: string
  active: boolean
  endDate: string
  hasRunOutPeriodEnded: boolean
  allowanceType: AllowanceType
  restrictedExpenseCategories: any[]
  sameClassForAll: boolean
  benefitDesignStatus: BenefitDesignStatus
  productClasses: ProductClassResponse[]
  notificationDate?: string
  isEarlyRunOutTriggered: boolean
  isEditable: boolean
  isNotificationDateEditable: boolean
  hasStarted: boolean
  runOutDays: number
  isContinuous: boolean
}

export type ProductClassResponse = {
  id: string
  name: string
  classTypeId: number
  designCompleted: boolean
  totalEmployees: number
  offerSameAllowance: boolean
  offerMaxAllowance?: boolean
  reimburseAnotherEmployeePlan: boolean
  isForFullTimeAndPartTime: boolean
}

const getBenefitDetails = (planPeriodId: string): Promise<BenefitDetailsResponse> => {
  return adminHttpClient.get(`/Benefit/Details/${planPeriodId}`)
}

export default getBenefitDetails
